export const NAME = 'ebon';

export const REGISTER_CART = 'REGISTER_CART';

export const SET_EBONS = 'SET_EBONS';

export const SET_ORDER = 'SET_ORDER';

export const REQUEST_PARTNERS_EBON = 'REQUEST_PARTNERS_EBON';
export const RECEIVE_PARTNERS_EBON = 'RECEIVE_PARTNERS_EBON';
export const FAILURE_PARTNERS_EBON = 'FAILURE_PARTNERS_EBON';

export const REQUEST_EBONS_PARTNER = 'REQUEST_EBONS_PARTNER';
export const RECEIVE_EBONS_PARTNER = 'RECEIVE_EBONS_PARTNER';
export const FAILURE_EBONS_PARTNER = 'FAILURE_EBONS_PARTNER';

export const REQUEST_EBONS_FAQ = 'REQUEST_EBONS_FAQ';
export const RECEIVE_EBONS_FAQ = 'RECEIVE_EBONS_FAQ';
export const FAILURE_EBONS_FAQ = 'FAILURE_EBONS_FAQ';

export const REQUEST_LOCK_EBONS = 'REQUEST_LOCK_EBONS';
export const RECEIVE_LOCK_EBONS = 'RECEIVE_LOCK_EBONS';
export const FAILURE_LOCK_EBONS = 'FAILURE_LOCK_EBONS';

export const REQUEST_CHECK_SMS = 'REQUEST_CHECK_SMS';
export const RECEIVE_CHECK_SMS = 'RECEIVE_CHECK_SMS';
export const FAILURE_CHECK_SMS = 'FAILURE_CHECK_SMS';

export const REQUEST_VALIDATE_SMS = 'REQUEST_VALIDATE_SMS';
export const RECEIVE_VALIDATE_SMS = 'RECEIVE_VALIDATE_SMS';
export const FAILURE_VALIDATE_SMS = 'FAILURE_VALIDATE_SMS';

export const REQUEST_CONFIRMATION_SMS = 'REQUEST_CONFIRMATION_SMS';
export const RECEIVE_CONFIRMATION_SMS = 'RECEIVE_CONFIRMATION_SMS';
export const FAILURE_CONFIRMATION_SMS = 'FAILURE_CONFIRMATION_SMS';

export const REQUEST_CREATE_ORDER = 'REQUEST_CREATE_ORDER';
export const RECEIVE_CREATE_ORDER = 'RECEIVE_CREATE_ORDER';
export const FAILURE_CREATE_ORDER = 'FAILURE_CREATE_ORDER';

export const REQUEST_EBONS_ORDER = 'REQUEST_EBONS_ORDER';
export const RECEIVE_EBONS_ORDER = 'RECEIVE_EBONS_ORDER';
export const FAILURE_EBONS_ORDER = 'FAILURE_EBONS_ORDER';

export const RESET_LOCK = 'RESET_LOCK';
export const RESET_CART = 'RESET_CART';

export const SET_PAYMENT_TYPE_VALUE = 'SET_PAYMENT_TYPE_VALUE';

export const REQUEST_EBONS_SEO = 'REQUEST_EBONS_SEO';
export const RECEIVE_EBONS_SEO = 'RECEIVE_EBONS_SEO';
export const FAILURE_EBONS_SEO = 'FAILURE_EBONS_SEO';



// WEBPACK FOOTER //
// ./src/services/ebon/constants.js